module.exports = __webpack_public_path__ + "static/media/Stellar Neo Queen Headboard - 155 cm_Charcoal.38d304a7.png";